/* global sessionStorage */
import {inlineError} from '@s-ui/decorators'

import UserRepository from '../Repositories/UserRepository.js'
import {UserConsentsStatusUserValueObject} from '../ValueObjects/UserConsentsStatusUserValueObject.js'
import {UserConsentUserValueObject} from '../ValueObjects/UserConsentUserValueObject.js'

/**
 * @class
 * @implements SellerRepository
 */
export class SessionStorageUserRepository extends UserRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {function} deps.contactTokenValueObjectFactory
   */
  constructor({config, contactTokenValueObjectFactory}) {
    super()

    this._config = config

    this._CONTACT_TOKEN_KEY = this._config.get('CONTACT_TOKEN_KEY')
    this._contactTokenValueObjectFactory = contactTokenValueObjectFactory

    this._USER_CONSENT_STORAGE_KEY = this._config.get('user').USER_CONSENT_STORAGE_KEY
    this._USER_CONSENTS = this._config.get('user').USER_CONSENTS
  }

  @inlineError
  async getConsentsStatus() {
    const userConsentStatusOnStorage = sessionStorage.getItem(this._USER_CONSENT_STORAGE_KEY)

    const hasUserConsentStatusOnStorage = userConsentStatusOnStorage !== null

    if (!hasUserConsentStatusOnStorage) sessionStorage.setItem(this._USER_CONSENT_STORAGE_KEY, false)

    return UserConsentsStatusUserValueObject.create({
      consents: [
        UserConsentUserValueObject.create({
          key: this._USER_CONSENTS.FINANCIAL_SERVICES,
          status: hasUserConsentStatusOnStorage ? JSON.parse(userConsentStatusOnStorage) : false
        })
      ]
    })
  }

  @inlineError
  async updateConsentsStatus({userConsentsStatusUserValueObject}) {
    const consentStatus = userConsentsStatusUserValueObject.getConsentStatus({
      key: this._USER_CONSENTS.FINANCIAL_SERVICES
    })

    sessionStorage.setItem(this._USER_CONSENT_STORAGE_KEY, consentStatus)

    return UserConsentsStatusUserValueObject.create({
      consents: [
        UserConsentUserValueObject.create({
          key: this._USER_CONSENTS.FINANCIAL_SERVICES,
          status: consentStatus
        })
      ]
    })
  }

  @inlineError
  async saveContactToken({contactTokenValueObject}) {
    sessionStorage.setItem(this._CONTACT_TOKEN_KEY, contactTokenValueObject.getContactToken())
    return Promise.resolve()
  }

  @inlineError
  async getContactToken() {
    const contactTokenOnStorage = sessionStorage.getItem(this._CONTACT_TOKEN_KEY)
    return this._contactTokenValueObjectFactory({
      contactToken: contactTokenOnStorage
    })
  }
}
